module.exports = __webpack_public_path__ + "static/media/facebook.b90bd092.jpg";